//
// Generated class CustomInputNoteLine
//

/// <reference path="CustomInputNoteLine_ManagedObject.ts" />

class CustomInputNoteLine extends CustomInputNoteLine_ManagedObject
{

}
